<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="title"
      [noBow]="title !== 'Attempt Details'"
      [canGoBack]="title === 'Attempt Details'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      <ng-container>
        <tidy-row [align]="'center'">
          @if (status !== 'failed') {
            <tidy-text
              [body]="'The request to your endpoint was successfull!'" />
          }
          @if (status === 'failed') {
            <tidy-text
              [body]="'The request to your endpoint failed. Please check that the url you added is correct and reach out to the concierge with any questions.'" />
          }
        </tidy-row>
        <tidy-button
          [text]="'Ok'"
          [action]="boundGoToWebhookDetails"
          class="primary" />
      </ng-container>
      @if (status === 'succeeded') {
        <tidy-card>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [header]="'Request to Your Endpoint'" />
          </tidy-row>
          <tidy-row>
            <tidy-json-formatter [dataJson]="requestJSON" />
          </tidy-row>
        </tidy-card>
        <tidy-card>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [header]="'Response'" />
          </tidy-row>
          <tidy-row>
            <tidy-json-formatter [dataJson]="responseJSON" />
          </tidy-row>
        </tidy-card>
      }
      @if (status === 'failed') {
        <tidy-card>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [header]="'Error:'" />
          </tidy-row>
          <tidy-row>
            <tidy-json-formatter [dataJson]="errorJSON" />
          </tidy-row>
        </tidy-card>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
